import * as type from './type'
import * as tableAction from '../../../table/state/action'
import { selectOwnState, selectTable } from './selector'

export const initialTableQuery = tableAction.createInitialTableQueryAction(selectOwnState, type.APPOINTMENT_TABLE)

export const changeFilter = tableAction.createChangeFilterAction(selectOwnState, type.APPOINTMENT_TABLE)

export const toggleSort = tableAction.createToggleSortAction(selectOwnState, type.APPOINTMENT_TABLE)

export const toggleMultiSort = tableAction.createToggleMultiSortAction(selectOwnState, type.APPOINTMENT_TABLE)

export const gotoPage = tableAction.createGotoPageAction(type.APPOINTMENT_TABLE)

export const initialTableSettings = tableAction.createInitialColumnsVisibilityTableHandler(type.APPOINTMENT_TABLE)

export const toggleColumnVisibility = tableAction.createToggleColumnVisibilityTableHandler(selectTable, type.APPOINTMENT_TABLE)






// WEBPACK FOOTER //
// ./src/modules/appointment/state/search/action.js